import { gql } from "@apollo/client";

const REJECT_NOMINATION = gql`
mutation RejectNomination($id: String){
    rejectNomination(id: $id)
    }
`;

export default REJECT_NOMINATION;
